import { render } from "./GreenButton.vue?vue&type=template&id=bc600a68&scoped=true"
import script from "./GreenButton.vue?vue&type=script&lang=js"
export * from "./GreenButton.vue?vue&type=script&lang=js"

import "./GreenButton.vue?vue&type=style&index=0&id=bc600a68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc600a68"]])

export default __exports__